/** T-47: Central de integrações e aba API e contas de integração. */
const en = {
  'integ.title': 'Integrations Center',
  'integ.sub': 'Every connection to other systems in one place. Each connection shows what it is used for, and each screen that uses it configures only its own use.',
  'integ.tab.catalog': 'Catalog',
  'integ.tab.health': 'Connection health',
  'integ.tab.api': 'API and integration accounts',
  'integ.tab.history': 'History',
  'integ.search': 'Search integration',
  'integ.searchPlaceholder': 'E.g. Entra, Teams, ServiceNow, Kafka',
  'integ.category': 'Category',
  'integ.stateFilter': 'State',
  'integ.direction': 'Direction',
  'integ.dir.all': 'All',
  'integ.dir.in': 'Inbound',
  'integ.dir.out': 'Outbound',
  'integ.dir.both': 'Inbound and outbound',
  'integ.dir.inHint': 'Brings data into Hive',
  'integ.dir.outHint': 'Takes data from Hive',
  'integ.dir.bothHint': 'Both ways',
  'integ.state.connected': 'Connected',
  'integ.state.attention': 'Attention',
  'integ.state.error': 'With error',
  'integ.state.available': 'Available',
  'integ.state.disabled': 'Turned off',
  'integ.sev.ok': 'OK',
  'integ.sev.attention': 'Attention',
  'integ.sev.error': 'Error',
  'integ.count.one': '{count} integration',
  'integ.count.other': '{count} integrations',
  'integ.connectedCount.one': '{count} in use',
  'integ.connectedCount.other': '{count} in use',
  'integ.none': 'No integration with this name.',
  'integ.noneText': 'For any tool with an API, the generic connector (REST/email) is in the ITSM category.',
  'integ.noOAuth': 'API route with POST · token or OAuth 2.0/SAML',
  'integ.open': 'Open',
  'integ.connect': 'Connect',
  'integ.cantConnect': 'Only profiles that administer integrations can connect.',
  'integ.backToCatalog': 'Back to the catalog',
  'integ.connectTitle': 'Connect {name}',
  'integ.connectSub': 'Fill in the fields of the integration. Secrets go to the vault and are never shown again.',
  'integ.connectSubNoOAuth': 'Hive calls the tool’s API route with POST. The credential comes from the vault: a fixed token, user and password, a fixed header, or OAuth 2.0 (Hive gets the token — with client credentials or a signed SAML assertion — and then posts with it).',
  'integ.testStep': 'Right after you connect, Hive tests the connection step by step and shows where it fails and how to fix it.',
  'integ.connected': '{name} connected.',
  'integ.connectedText': 'The first use is on; the others you turn on in the connection.',
  'integ.openConnection': 'Open the connection',
  'integ.test.title': 'Connection test',
  'integ.test.button': 'Test connection',
  'integ.test.running': 'Testing…',
  'integ.test.steps': 'Test steps',
  'integ.test.ok': 'The connection works.',
  'integ.test.failed': 'The test failed.',
  'integ.test.notAvailable': "This integration has no connection test: it is checked when it is used.",
  'integ.edit': 'Edit connection',
  'integ.editTitle': 'Edit {name}',
  'integ.editNote': 'Secret fields stay blank: type only if you want to replace the value kept in the vault.',
  'integ.editUnavailable': 'This integration is no longer in the catalog.',
  'integ.saved': '{name} saved.',
  'integ.disconnect.ok': 'Disconnect',
  'integ.disconnect.title': 'Disconnect {name}?',
  'integ.disconnect.text': 'Every use of this connection stops and the secrets are deleted from the vault. The history stays in the audit trail.',
  'integ.disconnect.done': '{name} disconnected.',
  'integ.uses.title': 'Uses of this connection',
  'integ.uses.none': 'This integration has no uses.',
  'integ.uses.hint': 'Each screen configures only the use (for example, which channel or which groups); the connection stays here.',
  'integ.use.enabled': 'On',
  'integ.use.disabled': 'Off',
  'integ.use.on': 'Use “{use}” turned on.',
  'integ.use.off': 'Use “{use}” turned off.',
  'integ.use.needsConsent': 'This use needs extra permission: {perms}.',
  'integ.use.perms': 'Permissions: {perms}',
  'integ.use.later': "Not available in this installation; offered on demand.",
  'integ.use.screenNote': 'Uses the connection credential; nothing to type again.',
  'integ.consent.open': 'Open consent',
  'integ.consent.title': 'Grant extra permission for “{use}”?',
  'integ.consent.text': 'Approve these permissions at the provider: {perms}. The use can be turned on afterwards.',
  'integ.consent.ok': 'I approved at the provider',
  'integ.consent.done': 'Permission recorded. You can turn on “{use}” now.',
  'integ.data.title': 'Connection data',
  'integ.data.createdBy': 'Created by',
  'integ.data.lastSync': 'Last successful test',
  'integ.data.never': 'never',
  'integ.health.title': 'Health',
  'integ.health.noneHere': 'No warnings for this connection.',
  'integ.health.empty': 'No connection to watch yet.',
  'integ.health.emptyText': 'Expiring credentials, revoked permissions and failed tests appear here, with the suggested fix.',
  'integ.health.connection': 'Connection',
  'integ.health.state': 'State',
  'integ.health.what': 'What is happening',
  'integ.health.fix': 'How to fix',
  'integ.health.checked': 'Checked',
  'integ.health.note': 'Problems here are about the connections themselves; alerts about assets are in Alerts and events.',
  'integ.history.title': 'History of this connection',
  'integ.history.empty': 'Nothing recorded yet.',
  'integ.history.when': 'When',
  'integ.history.who': 'Who',
  'integ.history.what': 'What changed',

  'api.intro.title': '100% of the platform is in the API.',
  'api.intro.text': 'Everything you see and do in Hive exists as a REST route (OpenAPI 3.1, /v1). ITSM, ESM and CMDB integrations never use OAuth: other platforms call Hive with the token of an integration account.',
  'api.new': 'New integration account',
  'api.reference': 'API documentation (Swagger)',
  'api.download': 'Download openapi.json',
  'api.docs.title': 'API documentation',
  'api.docs.back': 'API and integration accounts',
  'api.docs.intro': 'Every route of the platform, grouped by area, with parameters, bodies and responses. "Try it out" calls the API with your session token, under your permissions.',
  'api.docs.readOnly': 'Only GET requests can be tried by default.',
  'api.docs.allowWrite': 'Allow trying POST, PUT, PATCH and DELETE',
  'api.docs.writeOn': 'Write requests enabled: they change real data under your name.',
  'api.docs.confirmTitle': 'Allow write requests?',
  'api.docs.confirmText': 'Requests made here run for real with your session (create, change and delete data) and go to the audit log. Continue?',
  'api.docs.confirmOk': 'Allow',
  'api.docs.loadFail': 'Could not load the API documentation viewer from the core. You can still download the contract (openapi.json).',
  'alerts.expand': 'Expand',
  'alerts.expandHint': 'Open this alert in a larger window',
  'alerts.expandedHere': 'This alert is open in the expanded window.',
  'alerts.alwaysExpand': 'Always open expanded',
  'api.cmdbGuide': 'Populate your CMDB in 3 steps',
  'api.empty': 'No integration accounts yet.',
  'api.emptyText': 'Create one for each platform that reads or sends data, like the CMDB of ServiceNow or Power BI.',
  'api.col.account': 'Integration account',
  'api.col.access': 'Can access',
  'api.col.mode': 'Mode',
  'api.col.tokens': 'Token',
  'api.col.lastUse': 'Last use',
  'api.noPurpose': 'no description',
  'api.mode.read': 'Read only',
  'api.mode.rw': 'Read and send',
  'api.revoked': 'Revoked',
  'api.expires': 'expires {when}',
  'api.overlap': 'Two tokens valid during the switch (7 days).',
  'api.noActive': 'No valid token',
  'api.never': 'never',
  'api.rotate.ok': 'Switch token',
  'api.rotate.title': 'Switch the token of {name}?',
  'api.rotate.text': 'A new token is created now. The current one keeps working for 7 days, so the consuming platform can be updated without downtime; then it expires by itself.',
  'api.revoke.ok': 'Revoke',
  'api.revoke.title': 'Revoke {name}?',
  'api.revoke.text': 'Calls with this account stop right away. This cannot be undone: to connect again, create a new account.',
  'api.revoke.done': '{name} revoked. Its calls stopped now.',
  'api.created.title': 'Integration account created',
  'api.created.text': 'Account {name} created.',
  'api.rotated.title': 'New token for {name}',
  'api.rotated.text': 'New token created. The previous one is valid for 7 more days.',
  'api.once': 'Copy the token now: it is shown only this once and Hive keeps only a fingerprint of it.',
  'api.token': 'Token',
  'api.copyToken': 'Copy token',
  'api.example': 'Example call',
  'api.exampleHint': 'Replace <token> with the token above. Every call goes to the audit trail.',
  'api.test': 'Test the token now',
  'api.testOk': 'The token works: Hive recognized the integration account.',
  'api.testFail': 'The token was not accepted.',
  'api.copiedClose': 'I copied the token — close',
  'api.cmdb.title': 'Populate the CMDB of your platform',
  'api.cmdb.step1': 'Initial load in batch: export with CIs, classes and relationships (NDJSON or CSV, resumable).',
  'api.cmdb.step2': 'Only what changed: ask for the items new, changed and removed since the last sync token, with cursor paging.',
  'api.cmdb.step3': 'Change notices: Hive posts to your webhook on each change (HMAC signature), or publishes on the event bus.',
  'api.cmdb.note': 'Ready mapping to ServiceNow CSDM or DMTF CIM classes, chosen in the integration account. Changed CIs can also be pushed to a webhook: “CI webhook” column in the table above.',
  'api.inbound.title': 'Inbound routes (POST)',
  'api.inbound.text': 'Ticket updates, approved changes, CIs from other tools and external events arrive by POST, each route accepting only the token of an account with that scope.',
  'api.inbound.hint': 'Errors come in plain language (RFC 9457) with what happened, why and how to fix.',
  'fed.tab': 'Federation',
  'fed.lead': 'Machines read from other inventory and CMDB tools enter the inventory matched to the assets you already have. When two sources disagree, the lower priority number wins; the agent always wins on machines that have it.',
  'fed.sources': 'Federation sources',
  'fed.empty': 'No inventory or CMDB tool connected',
  'fed.emptyText': 'Connect SCCM, OCS, KACE, ServiceNow, GLPI, Snipe-IT, ManageEngine, Lansweeper, Ivanti, Tanium, BMC Helix or another Hive to bring their machines here.',
  'fed.emptyLink': 'See inventory integrations',
  'fed.col.source': 'Source',
  'fed.col.priority': 'Priority',
  'fed.col.every': 'Read every',
  'fed.col.last': 'Last read',
  'fed.col.assets': 'Assets',
  'fed.col.actions': 'Actions',
  'fed.col.asset': 'Asset',
  'fed.col.field': 'Field',
  'fed.col.current': 'Value in the asset',
  'fed.col.said': 'What each source says',
  'fed.hours': '{n} h',
  'fed.machines': '{n} machines',
  'fed.status.ok': 'Read',
  'fed.status.running': 'Reading',
  'fed.status.failed': 'Failed',
  'fed.status.stopped': 'Stopped',
  'fed.status.never': 'Not read yet',
  'fed.test': 'Test',
  'fed.testing': 'Testing…',
  'fed.sync': 'Read now',
  'fed.syncing': 'Reading…',
  'fed.testOk': '{name} answered: the collector reached the tool and read a machine.',
  'fed.syncOk': '{name} read: {n} machines applied to the inventory.',
  'fed.failed': '{name} could not be read.',
  'fed.saved': 'Source saved; the assets were evaluated again.',
  'fed.precedence': 'Precedence: agent (0) › field rules › source priority. A machine that disappears from a complete read loses the link to that source; the asset stays.',
  'fed.rules': 'Rules per field',
  'fed.rulesLead': 'Use when a source is the reference for one field only, for example the model from the asset management tool.',
  'fed.addRule': 'Add rule',
  'fed.removeRule': 'Remove rule',
  'fed.saveRules': 'Save rules',
  'fed.rulesSaved': 'Rules saved; the assets were evaluated again.',
  'fed.conflicts': 'Conflicts between sources',
  'fed.noConflicts': 'The sources agree on every field.',
  'fed.agent': 'agent',
  'fed.field.hostname': 'Name',
  'fed.field.fqdn': 'FQDN',
  'fed.field.serial': 'Serial number',
  'fed.field.hwUuid': 'Hardware UUID',
  'fed.field.vendor': 'Manufacturer',
  'fed.field.model': 'Model',
  'fed.field.osName': 'Operating system',
  'fed.field.osVersion': 'OS version',
  'fed.field.primaryUser': 'Main user',
  'fed.field.assetTag': 'Asset tag',
  'fed.asset.tab': 'Sources',
  'fed.asset.title': 'Where each piece of data came from',
  'fed.asset.lead': 'Each field shows the value in use, who provided it and what every source says.',
  'fed.asset.agent': 'Agent · last seen {when}',
  'fed.asset.noAgent': 'No agent',
  'fed.asset.from': 'Provided by',
  'fed.asset.conflict': 'Differs',
  'fed.asset.priority': 'priority {n}',
  'fed.asset.empty': 'Only the agent informs this asset',
  'fed.asset.emptyText': 'When an inventory or CMDB tool also knows this machine, what it says appears here.',
  'rpx.title': "Read proxy (optional)",
  'rpx.lead': "Another platform reads Hive data through a light proxy in the DMZ (hive-readproxy): only GET on the fixed routes below, with the platform's own read-only integration account, short cache, rate limit and every read in the audit trail. It never reaches tasks, deployments, scripts, remote access or agents.",
  'rpx.state.on': "On",
  'rpx.state.off': "Off",
  'rpx.turnOn': "Turn on",
  'rpx.turnOff': "Turn off",
  'rpx.rotate': "New proxy key",
  'rpx.key': "Proxy key ending in {last4}",
  'rpx.noKey': "No key yet: it is created when the proxy is turned on.",
  'rpx.changed': "Changed by {who} {when}",
  'rpx.keyOnce': "Copy the proxy key now: it is shown only once. Put it in the proxy configuration (-key-file).",
  'rpx.copyKey': "Copy key",
  'rpx.routes': "Exposed routes (GET only)",
  'rpx.col.path': "Route",
  'rpx.col.domain': "Data",
  'rpx.col.scopes': "Account needs",
  'rpx.domain.assets': "Assets",
  'rpx.domain.alerts': "Alerts",
  'rpx.domain.vulnerabilities': "Vulnerabilities",
  'rpx.domain.metrics': "Metrics",
  'rpx.headers': "The proxy sends its key to Hive in {key} and the platform address in {client}.",
  'rpx.on': "Read proxy turned on",
  'rpx.off': "Read proxy turned off",
  'rpx.rotated': "New proxy key created; the previous one stopped working.",
  'rpx.rotateConfirm.title': "Create a new proxy key?",
  'rpx.rotateConfirm.text': "The current key stops working at once; update the proxy configuration with the new one.",
  'rpx.offConfirm.title': "Turn the read proxy off?",
  'rpx.offConfirm.text': "Reads through the proxy are refused at once. The API with integration accounts keeps working.",
  'iso.button': "Isolate from the network",
  'iso.lead': "After the approval, the agent blocks all traffic with the system firewall, except the channel with Hive, DNS and DHCP. It ends by itself when the safety expiry passes, even without Hive.",
  'iso.leadEdr': "The EDR connected to this device isolates it after the approval.",
  'iso.via': "Isolate through",
  'iso.via.agent': "Hive agent (system firewall)",
  'iso.via.edr': "EDR sensor",
  'iso.minutes': "Safety expiry (minutes)",
  'iso.minutesHint': "Between 5 minutes and 7 days; the agent releases the device by itself when it passes.",
  'iso.ports': "Service ports kept open (servers)",
  'iso.portsHint': "TCP ports, separated by commas (e.g. 443, 1433). Leave empty on workstations.",
  'iso.state.on': "Isolated until {when}",
  'iso.state.onEdr': "Isolated by the EDR",
  'iso.state.off': "Not isolated",
  'iso.state.expired': "Isolation ended {when} (safety expiry)",
  'iso.open': "An isolation request is waiting or running.",
  'iso.effect': "The device leaves the network; only the channel with Hive (and the declared service ports) stays open until the safety expiry.",
  'rsp.a.release': "Release from network isolation",
  'rsp.effect.release': "The device returns to the network: the agent removes its firewall rules (or the EDR releases it).",
  'dc.cap.response-isolate': "Isolate from the network and release",
  'integ.onDemandHint': "This connector is not part of the product yet. Ask for it and the Hive team sees your request.",
  'integ.request': "Request this connector",
  'integ.requested': "Request for {name} recorded: it is in the audit trail and the Hive team was told.",
  'integ.builtin': "Already included — syncs on its own",
  'integ.builtin.sub': "Public vulnerability sources that come with Hive: nothing to connect.",
  'integ.builtin.lead': "Hive reads these public sources by itself, for every company: CISA KEV and NVD every 2 hours (the NVD only for the products in use), OSV.dev every 6 hours and FIRST EPSS once a day.",
  'integ.feed.kev': "CISA KEV",
  'integ.feed.nvd': "NVD",
  'integ.feed.osv': "OSV.dev",
  'integ.feed.epss': "FIRST EPSS",
  'integ.feed.state.ok': "Up to date",
  'integ.feed.state.stale': "Out of date",
  'integ.feed.state.attention': "Failing",
  'integ.feed.state.never': "Not synced yet",
  'integ.feed.last': "synced {when}",
  'integ.feed.never': "never synced",
  'integ.feed.every': "every {n} h",
  'integ.feed.unreachable': "The server does not reach {hosts}. Allow HTTPS (port 443) to these addresses in the firewall, the proxy or the OpenShift egress.",
  'integ.feed.error': "last error: {error}",
  'integ.feed.hosts': "Addresses the server reaches (HTTPS): {hosts}.",
  'integ.feed.fixNow': "Open Fix now",
  'integ.feed.details': "Details",
  'integ.nvdKey.title': "NVD API key (optional)",
  'integ.nvdKey.hint': "With a key, the NVD sync is about ten times faster and the NVD refuses fewer requests for going over its limit. Ask for one, free, at nvd.nist.gov/developers/request-an-api-key. It is kept in the vault and applies on the next sync, without a restart.",
  'integ.nvdKey.set': "A key is saved. Type a new one to replace it, or remove it.",
  'integ.nvdKey.none': "No key: the sync waits between pages to respect the public limit.",
  'integ.nvdKey.field': "API key",
  'integ.nvdKey.save': "Save key",
  'integ.nvdKey.remove': "Remove key",
  'integ.nvdKey.saved': "NVD key saved. It applies on the next sync.",
  'integ.nvdKey.removed': "NVD key removed.",
  'integ.nvdKey.adminOnly': "Only the installation administrators change the key.",
  'tk.label': "Ticket",
  'tk.search': "Search by number, title, requester or CI",
  'tk.searchHint': "Searches {tool}. The tickets of this device and yours come first; typing the number also works.",
  'tk.noItsm': "No ITSM is connected: type the ticket number.",
  'tk.noRead': "{tool} does not allow searching from Hive: the number is kept as typed.",
  'tk.readOff': "Reading tickets is turned off in the ITSM integration: the number is kept as typed.",
  'tk.searching': "Searching the ITSM…",
  'tk.none': "No ticket found for \"{q}\". Type the full number or open a new ticket.",
  'tk.results': "Tickets in the ITSM",
  'tk.notFound': "Not found in the ITSM. Check the number or choose it from the list.",
  'tk.unreachable': "The ITSM did not answer; Hive checks the number again when you save.",
  'tk.open': "Open ticket",
  'tk.openTitle': "Open a ticket in {tool}",
  'tk.openText': "Hive opens the ticket now with the device, the reason and who asks, using the category, group and priority of the integration mapping.",
  'tk.openTitleField': "Title",
  'tk.openDescField': "Description",
  'tk.openConfirm': "Open in the ITSM",
  'tk.opened': "Ticket {key} opened in the ITSM.",
  'tk.openInItsm': "Open in the ITSM",
  'tk.summary': "Ticket {key}",
  'tk.state.open': "Open",
  'tk.state.progress': "In progress",
  'tk.state.waiting': "Waiting",
  'tk.state.resolved': "Resolved",
  'tk.state.closed': "Closed",
  'tk.priority': "Priority",
  'tk.requester': "Requester",
  'tk.assignee': "Assignee",
  'tk.assignedTo': "with {who}",
  'tk.ci': "CI",
  'tk.updated': "Updated",
  'tk.notes': "Latest notes",
  'tk.requiredSr': "required",
  'tk.requiredHint': "required by the ITSM integration",
  'tk.required': "This screen requires an ITSM ticket: choose one or open a new one in the field.",
  'tk.closeQ': "Also close ticket {key} in the ITSM?",
  'tk.closeText': "Hive resolves the ticket with the close code of the integration and a note of what was done.",
  'tk.closeOk': "Close the ticket",
  'tk.closeKeep': "Keep it open",
  'tk.closed': "Ticket closed in the ITSM.",
  'tk.closeBtn': "Close ticket",
  'tk.asset.title': "ITSM tickets",
  'tk.asset.empty': "No ITSM ticket linked to this device yet.",
  'tk.col.ticket': "Ticket",
  'tk.col.where': "Where",
  'tk.col.by': "By",
  'tk.col.when': "When",
  'tk.unverified': "not checked in the ITSM",
  'tk.closedTag': "closed by Hive",
  'tk.screen.remote': "Remote access",
  'tk.screen.elevation': "Temporary administrator",
  'tk.screen.change-window': "Change window (integrity)",
  'tk.screen.net-change-window': "Change window (network)",
  'tk.screen.risk-acceptance': "Risk acceptance",
  'tk.screen.device-exception': "USB exception",
  'tk.screen.deployment': "Deployment and patches",
  'tk.screen.access-review': "Access review",
  'tk.screen.incident-response': "Incident response",
  'tk.screen.asset-stage': "Maintenance (lifecycle)",
  'tk.screen.remote-unattended': "Unattended remote access",
  'tkf.title': "Ticket fields",
  'tkf.lead': "How the \"Ticket\" field of every screen (remote access, change windows, exceptions, deployments, access review, incident response) uses this ITSM.",
  'tkf.uses': "Uses",
  'tkf.read': "Read: search and show the ticket summary",
  'tkf.readHint': "Without reading the number is kept as typed and is not checked.",
  'tkf.open': "Open: \"Open ticket\" in the field, prefilled",
  'tkf.update': "Update: Hive writes what happened in the ticket",
  'tkf.close': "Close: resolve the ticket when the work ends (with confirmation)",
  'tkf.notReadable': "{tool} does not allow searching from Hive yet: reading works with ServiceNow, Jira Service Management and GLPI.",
  'tkf.notes': "Notes written in the ticket",
  'tkf.notesHint': "Markers: {asset} {actor} {by} {reason} {duration} {what} {result} {from} {to}. Leave the default text to keep it in the company language.",
  'tkf.event.linked': "Ticket linked to a record",
  'tkf.event.remote.requested': "Remote access requested",
  'tkf.event.remote.approved': "Remote access approved",
  'tkf.event.remote.started': "Remote session started",
  'tkf.event.remote.ended': "Remote session ended (with duration)",
  'tkf.event.change.scheduled': "Change window registered",
  'tkf.event.change.applied': "Change applied (deployment done, review closed, response done)",
  'tkf.event.exception.approved': "Exception approved",
  'tkf.closeOn': "Close by itself when",
  'tkf.closeCode': "Close code",
  'tkf.closeCodeHint': "ServiceNow: close code (e.g. Solved Remotely (Permanently)); Jira: transition id; GLPI: solution type id. Empty: the connection default.",
  'tkf.fields': "Fields when opening from Hive",
  'tkf.fieldsHint': "Empty: the connection mapping (severity, groups by tag, categories) applies.",
  'tkf.field.category': "Category",
  'tkf.field.group': "Group",
  'tkf.field.priority': "Priority",
  'tkf.states': "States of the tool",
  'tkf.statesHint': "A tool state Hive does not recognize (e.g. a custom one) shows as the Hive state chosen here.",
  'tkf.stateRaw': "State in the tool",
  'tkf.stateHive': "State in Hive",
  'tkf.addState': "Add state",
  'tkf.remove': "Remove",
  'tkf.required': "Ticket required",
  'tkf.requiredHint': "On the chosen screens, saving without a valid ticket is refused with the explanation. A resolved or closed ticket is not accepted.",
  'tkf.save': "Save ticket field options",
  'tkf.saved': "Ticket field options saved.",
} as const;

type K = keyof typeof en;

const ptBR: Record<K, string> = {
  'integ.title': 'Central de integrações',
  'integ.sub': 'Todas as conexões com outros sistemas num só lugar. Cada conexão mostra para que é usada, e cada tela que a usa configura só o próprio uso.',
  'integ.tab.catalog': 'Catálogo',
  'integ.tab.health': 'Saúde das conexões',
  'integ.tab.api': 'API e contas de integração',
  'integ.tab.history': 'Histórico',
  'integ.search': 'Procurar integração',
  'integ.searchPlaceholder': 'Ex.: Entra, Teams, ServiceNow, Kafka',
  'integ.category': 'Categoria',
  'integ.stateFilter': 'Estado',
  'integ.direction': 'Direção',
  'integ.dir.all': 'Todas',
  'integ.dir.in': 'Entrada',
  'integ.dir.out': 'Saída',
  'integ.dir.both': 'Entrada e saída',
  'integ.dir.inHint': 'Traz dados para o Hive',
  'integ.dir.outHint': 'Leva dados do Hive',
  'integ.dir.bothHint': 'Nos dois sentidos',
  'integ.state.connected': 'Conectada',
  'integ.state.attention': 'Atenção',
  'integ.state.error': 'Com erro',
  'integ.state.available': 'Disponível',
  'integ.state.disabled': 'Desligada',
  'integ.sev.ok': 'OK',
  'integ.sev.attention': 'Atenção',
  'integ.sev.error': 'Erro',
  'integ.count.one': '{count} integração',
  'integ.count.other': '{count} integrações',
  'integ.connectedCount.one': '{count} em uso',
  'integ.connectedCount.other': '{count} em uso',
  'integ.none': 'Nenhuma integração com esse nome.',
  'integ.noneText': 'Para qualquer ferramenta com API, o conector genérico (REST/e-mail) está na categoria ITSM.',
  'integ.noOAuth': 'Rota de API com POST · token ou OAuth 2.0/SAML',
  'integ.open': 'Abrir',
  'integ.connect': 'Conectar',
  'integ.cantConnect': 'Só perfis que administram integrações podem conectar.',
  'integ.backToCatalog': 'Voltar ao catálogo',
  'integ.connectTitle': 'Conectar {name}',
  'integ.connectSub': 'Preencha os campos da integração. Segredos vão para o cofre e nunca voltam a aparecer.',
  'integ.connectSubNoOAuth': 'O Hive chama a rota de API da ferramenta com POST. A credencial vem do cofre: token fixo, usuário e senha, cabeçalho fixo ou OAuth 2.0 (o Hive pega o token — com client credentials ou asserção SAML assinada — e depois faz o POST com ele).',
  'integ.testStep': 'Logo depois de conectar, o Hive testa a conexão passo a passo e mostra onde falha e como corrigir.',
  'integ.connected': '{name} conectado.',
  'integ.connectedText': 'O primeiro uso já está ligado; os outros você liga na conexão.',
  'integ.openConnection': 'Abrir a conexão',
  'integ.test.title': 'Teste da conexão',
  'integ.test.button': 'Testar conexão',
  'integ.test.running': 'Testando…',
  'integ.test.steps': 'Passos do teste',
  'integ.test.ok': 'A conexão funciona.',
  'integ.test.failed': 'O teste falhou.',
  'integ.test.notAvailable': "Esta integração não tem teste de conexão: ela é conferida quando é usada.",
  'integ.edit': 'Editar conexão',
  'integ.editTitle': 'Editar {name}',
  'integ.editNote': 'Campos secretos ficam em branco: digite só se quiser trocar o valor guardado no cofre.',
  'integ.editUnavailable': 'Esta integração não está mais no catálogo.',
  'integ.saved': '{name} salvo.',
  'integ.disconnect.ok': 'Desconectar',
  'integ.disconnect.title': 'Desconectar {name}?',
  'integ.disconnect.text': 'Todos os usos desta conexão param e os segredos são apagados do cofre. O histórico continua na trilha de auditoria.',
  'integ.disconnect.done': '{name} desconectado.',
  'integ.uses.title': 'Usos desta conexão',
  'integ.uses.none': 'Esta integração não tem usos.',
  'integ.uses.hint': 'Cada tela configura só o uso (por exemplo, qual canal ou quais grupos); a conexão fica aqui.',
  'integ.use.enabled': 'Ligado',
  'integ.use.disabled': 'Desligado',
  'integ.use.on': 'Uso “{use}” ligado.',
  'integ.use.off': 'Uso “{use}” desligado.',
  'integ.use.needsConsent': 'Este uso precisa de permissão extra: {perms}.',
  'integ.use.perms': 'Permissões: {perms}',
  'integ.use.later': "Não disponível nesta instalação; oferecido sob demanda.",
  'integ.use.screenNote': 'Usa a credencial da conexão; nada para digitar de novo.',
  'integ.consent.open': 'Abrir consentimento',
  'integ.consent.title': 'Conceder permissão extra para “{use}”?',
  'integ.consent.text': 'Aprove estas permissões no provedor: {perms}. Depois o uso pode ser ligado.',
  'integ.consent.ok': 'Aprovei no provedor',
  'integ.consent.done': 'Permissão registrada. Já dá para ligar “{use}”.',
  'integ.data.title': 'Dados da conexão',
  'integ.data.createdBy': 'Criada por',
  'integ.data.lastSync': 'Último teste com sucesso',
  'integ.data.never': 'nunca',
  'integ.health.title': 'Saúde',
  'integ.health.noneHere': 'Nenhum aviso para esta conexão.',
  'integ.health.empty': 'Ainda não há conexão para acompanhar.',
  'integ.health.emptyText': 'Credenciais vencendo, permissões revogadas e testes com falha aparecem aqui, com a correção sugerida.',
  'integ.health.connection': 'Conexão',
  'integ.health.state': 'Estado',
  'integ.health.what': 'O que está acontecendo',
  'integ.health.fix': 'Como resolver',
  'integ.health.checked': 'Verificado',
  'integ.health.note': 'Os problemas aqui são das próprias conexões; alertas sobre ativos ficam em Alertas e eventos.',
  'integ.history.title': 'Histórico desta conexão',
  'integ.history.empty': 'Nada registrado ainda.',
  'integ.history.when': 'Quando',
  'integ.history.who': 'Quem',
  'integ.history.what': 'O que mudou',

  'api.intro.title': '100% da plataforma está na API.',
  'api.intro.text': 'Tudo o que você vê e faz no Hive existe como rota REST (OpenAPI 3.1, /v1). Integrações com ITSM, ESM e CMDB nunca usam OAuth: as outras plataformas chamam o Hive com o token de uma conta de integração.',
  'api.new': 'Nova conta de integração',
  'api.reference': 'Documentação da API (Swagger)',
  'api.download': 'Baixar openapi.json',
  'api.docs.title': 'Documentação da API',
  'api.docs.back': 'API e contas de integração',
  'api.docs.intro': 'Todas as rotas da plataforma, agrupadas por área, com parâmetros, corpos e respostas. "Try it out" chama a API com o token da sua sessão, dentro das suas permissões.',
  'api.docs.readOnly': 'Por padrão, só dá para experimentar pedidos GET.',
  'api.docs.allowWrite': 'Permitir experimentar POST, PUT, PATCH e DELETE',
  'api.docs.writeOn': 'Pedidos de escrita liberados: eles alteram dados reais em seu nome.',
  'api.docs.confirmTitle': 'Liberar pedidos de escrita?',
  'api.docs.confirmText': 'Os pedidos feitos aqui são reais e usam a sua sessão (criam, alteram e apagam dados) e vão para a auditoria. Continuar?',
  'api.docs.confirmOk': 'Liberar',
  'api.docs.loadFail': 'Não foi possível carregar o visualizador da documentação a partir do núcleo. Você ainda pode baixar o contrato (openapi.json).',
  'alerts.expand': 'Ampliar',
  'alerts.expandHint': 'Abrir este alerta numa janela maior',
  'alerts.expandedHere': 'Este alerta está aberto na janela ampliada.',
  'alerts.alwaysExpand': 'Abrir sempre ampliado',
  'api.cmdbGuide': 'Popular sua CMDB em 3 passos',
  'api.empty': 'Ainda não há contas de integração.',
  'api.emptyText': 'Crie uma para cada plataforma que lê ou envia dados, como a CMDB do ServiceNow ou o Power BI.',
  'api.col.account': 'Conta de integração',
  'api.col.access': 'Pode acessar',
  'api.col.mode': 'Modo',
  'api.col.tokens': 'Token',
  'api.col.lastUse': 'Último uso',
  'api.noPurpose': 'sem descrição',
  'api.mode.read': 'Somente leitura',
  'api.mode.rw': 'Leitura e envio',
  'api.revoked': 'Revogada',
  'api.expires': 'vence {when}',
  'api.overlap': 'Dois tokens valendo durante a troca (7 dias).',
  'api.noActive': 'Nenhum token válido',
  'api.never': 'nunca',
  'api.rotate.ok': 'Trocar token',
  'api.rotate.title': 'Trocar o token de {name}?',
  'api.rotate.text': 'Um token novo é criado agora. O atual continua valendo por 7 dias, para dar tempo de atualizar a plataforma que consome sem parada; depois expira sozinho.',
  'api.revoke.ok': 'Revogar',
  'api.revoke.title': 'Revogar {name}?',
  'api.revoke.text': 'As chamadas com esta conta param na hora. Não dá para desfazer: para conectar de novo, crie uma conta nova.',
  'api.revoke.done': '{name} revogada. As chamadas dela pararam agora.',
  'api.created.title': 'Conta de integração criada',
  'api.created.text': 'Conta {name} criada.',
  'api.rotated.title': 'Novo token para {name}',
  'api.rotated.text': 'Token novo criado. O anterior vale por mais 7 dias.',
  'api.once': 'Copie o token agora: ele aparece só esta vez e o Hive guarda apenas uma impressão digital dele.',
  'api.token': 'Token',
  'api.copyToken': 'Copiar token',
  'api.example': 'Exemplo de chamada',
  'api.exampleHint': 'Troque <token> pelo token acima. Cada chamada vai para a trilha de auditoria.',
  'api.test': 'Testar o token agora',
  'api.testOk': 'O token funciona: o Hive reconheceu a conta de integração.',
  'api.testFail': 'O token não foi aceito.',
  'api.copiedClose': 'Copiei o token — fechar',
  'api.cmdb.title': 'Popular a CMDB da sua plataforma',
  'api.cmdb.step1': 'Carga inicial em lote: exportação com CIs, classes e relacionamentos (NDJSON ou CSV, retomável).',
  'api.cmdb.step2': 'Só o que mudou: peça os itens novos, alterados e removidos desde o último token de sincronização, com paginação por cursor.',
  'api.cmdb.step3': 'Avisos de mudança: o Hive faz POST no seu webhook a cada mudança (assinatura HMAC), ou publica no barramento.',
  'api.cmdb.note': 'Mapeamento pronto para classes do ServiceNow CSDM ou DMTF CIM, escolhido na conta de integração. CIs alterados também podem ir para um webhook: coluna “Webhook de CI” na tabela acima.',
  'api.inbound.title': 'Rotas de entrada (POST)',
  'api.inbound.text': 'Atualizações de chamados, mudanças aprovadas, CIs de outras ferramentas e eventos externos chegam por POST, cada rota aceitando só o token de uma conta com esse escopo.',
  'api.inbound.hint': 'Os erros vêm em linguagem clara (RFC 9457), com o que houve, por quê e como resolver.',
  'fed.tab': 'Federação',
  'fed.lead': 'As máquinas lidas de outras ferramentas de inventário e CMDB entram no inventário casadas com os ativos que você já tem. Quando duas fontes discordam, vence o menor número de prioridade; o agente sempre vence nas máquinas que o têm.',
  'fed.sources': 'Fontes da federação',
  'fed.empty': 'Nenhuma ferramenta de inventário ou CMDB conectada',
  'fed.emptyText': 'Conecte SCCM, OCS, KACE, ServiceNow, GLPI, Snipe-IT, ManageEngine, Lansweeper, Ivanti, Tanium, BMC Helix ou outro Hive para trazer as máquinas deles para cá.',
  'fed.emptyLink': 'Ver integrações de inventário',
  'fed.col.source': 'Fonte',
  'fed.col.priority': 'Prioridade',
  'fed.col.every': 'Ler a cada',
  'fed.col.last': 'Última leitura',
  'fed.col.assets': 'Ativos',
  'fed.col.actions': 'Ações',
  'fed.col.asset': 'Ativo',
  'fed.col.field': 'Campo',
  'fed.col.current': 'Valor no ativo',
  'fed.col.said': 'O que cada fonte diz',
  'fed.hours': '{n} h',
  'fed.machines': '{n} máquinas',
  'fed.status.ok': 'Lida',
  'fed.status.running': 'Lendo',
  'fed.status.failed': 'Falhou',
  'fed.status.stopped': 'Parada',
  'fed.status.never': 'Ainda não lida',
  'fed.test': 'Testar',
  'fed.testing': 'Testando…',
  'fed.sync': 'Ler agora',
  'fed.syncing': 'Lendo…',
  'fed.testOk': '{name} respondeu: o coletor alcançou a ferramenta e leu uma máquina.',
  'fed.syncOk': '{name} lida: {n} máquinas aplicadas no inventário.',
  'fed.failed': 'Não foi possível ler {name}.',
  'fed.saved': 'Fonte salva; os ativos foram reavaliados.',
  'fed.precedence': 'Precedência: agente (0) › regras por campo › prioridade da fonte. A máquina que some numa leitura completa perde o vínculo com aquela fonte; o ativo continua.',
  'fed.rules': 'Regras por campo',
  'fed.rulesLead': 'Use quando uma fonte é a referência só para um campo, por exemplo o modelo vindo da ferramenta de gestão de ativos.',
  'fed.addRule': 'Adicionar regra',
  'fed.removeRule': 'Remover regra',
  'fed.saveRules': 'Salvar regras',
  'fed.rulesSaved': 'Regras salvas; os ativos foram reavaliados.',
  'fed.conflicts': 'Conflitos entre fontes',
  'fed.noConflicts': 'As fontes concordam em todos os campos.',
  'fed.agent': 'agente',
  'fed.field.hostname': 'Nome',
  'fed.field.fqdn': 'FQDN',
  'fed.field.serial': 'Número de série',
  'fed.field.hwUuid': 'UUID do hardware',
  'fed.field.vendor': 'Fabricante',
  'fed.field.model': 'Modelo',
  'fed.field.osName': 'Sistema operacional',
  'fed.field.osVersion': 'Versão do sistema',
  'fed.field.primaryUser': 'Usuário principal',
  'fed.field.assetTag': 'Patrimônio',
  'fed.asset.tab': 'Fontes',
  'fed.asset.title': 'De onde veio cada dado',
  'fed.asset.lead': 'Cada campo mostra o valor em uso, quem o informou e o que cada fonte diz.',
  'fed.asset.agent': 'Agente · visto {when}',
  'fed.asset.noAgent': 'Sem agente',
  'fed.asset.from': 'Informado por',
  'fed.asset.conflict': 'Diverge',
  'fed.asset.priority': 'prioridade {n}',
  'fed.asset.empty': 'Só o agente informa este ativo',
  'fed.asset.emptyText': 'Quando uma ferramenta de inventário ou CMDB também conhecer esta máquina, o que ela diz aparece aqui.',
  'rpx.title': "Proxy de leitura (opcional)",
  'rpx.lead': "Outra plataforma lê os dados do Hive por um proxy leve na DMZ (hive-readproxy): só GET nas rotas fixas abaixo, com a conta de integração somente leitura da própria plataforma, cache curto, limite de chamadas e cada leitura na trilha de auditoria. Ele nunca alcança tarefas, implantações, scripts, acesso remoto nem agentes.",
  'rpx.state.on': "Ligado",
  'rpx.state.off': "Desligado",
  'rpx.turnOn': "Ligar",
  'rpx.turnOff': "Desligar",
  'rpx.rotate': "Nova chave do proxy",
  'rpx.key': "Chave do proxy terminada em {last4}",
  'rpx.noKey': "Ainda sem chave: ela é criada ao ligar o proxy.",
  'rpx.changed': "Alterado por {who} {when}",
  'rpx.keyOnce': "Copie a chave do proxy agora: ela aparece uma única vez. Coloque-a na configuração do proxy (-key-file).",
  'rpx.copyKey': "Copiar chave",
  'rpx.routes': "Rotas expostas (só GET)",
  'rpx.col.path': "Rota",
  'rpx.col.domain': "Dados",
  'rpx.col.scopes': "A conta precisa de",
  'rpx.domain.assets': "Ativos",
  'rpx.domain.alerts': "Alertas",
  'rpx.domain.vulnerabilities': "Vulnerabilidades",
  'rpx.domain.metrics': "Métricas",
  'rpx.headers': "O proxy envia a chave ao Hive em {key} e o endereço da plataforma em {client}.",
  'rpx.on': "Proxy de leitura ligado",
  'rpx.off': "Proxy de leitura desligado",
  'rpx.rotated': "Nova chave do proxy criada; a anterior parou de valer.",
  'rpx.rotateConfirm.title': "Criar uma nova chave do proxy?",
  'rpx.rotateConfirm.text': "A chave atual para de valer na hora; atualize a configuração do proxy com a nova.",
  'rpx.offConfirm.title': "Desligar o proxy de leitura?",
  'rpx.offConfirm.text': "As leituras pelo proxy passam a ser recusadas na hora. A API com contas de integração continua funcionando.",
  'iso.button': "Isolar da rede",
  'iso.lead': "Depois da aprovação, o agente bloqueia todo o tráfego pelo firewall do sistema, menos o canal com o Hive, o DNS e o DHCP. Acaba sozinho quando o prazo de segurança vence, mesmo sem o Hive.",
  'iso.leadEdr': "O EDR conectado a esta máquina a isola depois da aprovação.",
  'iso.via': "Isolar por",
  'iso.via.agent': "Agente do Hive (firewall do sistema)",
  'iso.via.edr': "Sensor do EDR",
  'iso.minutes': "Prazo de segurança (minutos)",
  'iso.minutesHint': "Entre 5 minutos e 7 dias; o agente libera a máquina sozinho quando ele vence.",
  'iso.ports': "Portas do serviço mantidas abertas (servidores)",
  'iso.portsHint': "Portas TCP separadas por vírgula (ex.: 443, 1433). Deixe vazio em estações.",
  'iso.state.on': "Isolada até {when}",
  'iso.state.onEdr': "Isolada pelo EDR",
  'iso.state.off': "Não isolada",
  'iso.state.expired': "Isolamento acabou {when} (prazo de segurança)",
  'iso.open': "Há um pedido de isolamento esperando ou em execução.",
  'iso.effect': "A máquina sai da rede; só o canal com o Hive (e as portas de serviço declaradas) continua aberto até o prazo de segurança.",
  'rsp.a.release': "Liberar do isolamento de rede",
  'rsp.effect.release': "A máquina volta à rede: o agente tira as regras do firewall (ou o EDR a libera).",
  'dc.cap.response-isolate': "Isolar da rede e liberar",
  'integ.onDemandHint': "Este conector ainda não faz parte do produto. Peça e a equipe do Hive vê o seu pedido.",
  'integ.request': "Pedir este conector",
  'integ.requested': "Pedido de {name} registrado: está na auditoria e a equipe do Hive foi avisada.",
  'integ.builtin': "Já incluída — sincroniza sozinha",
  'integ.builtin.sub': "Bases públicas de vulnerabilidade que já vêm com o Hive: não há o que conectar.",
  'integ.builtin.lead': "O Hive lê estas bases públicas sozinho, para todas as empresas: o CISA KEV e a NVD a cada 2 horas (a NVD só para os produtos em uso), o OSV.dev a cada 6 horas e o FIRST EPSS uma vez por dia.",
  'integ.feed.kev': "CISA KEV",
  'integ.feed.nvd': "NVD",
  'integ.feed.osv': "OSV.dev",
  'integ.feed.epss': "FIRST EPSS",
  'integ.feed.state.ok': "Em dia",
  'integ.feed.state.stale': "Desatualizada",
  'integ.feed.state.attention': "Falhando",
  'integ.feed.state.never': "Ainda não sincronizada",
  'integ.feed.last': "sincronizada {when}",
  'integ.feed.never': "nunca sincronizada",
  'integ.feed.every': "a cada {n} h",
  'integ.feed.unreachable': "O servidor não alcança {hosts}. Libere HTTPS (porta 443) para esses endereços no firewall, no proxy ou no egress do OpenShift.",
  'integ.feed.error': "último erro: {error}",
  'integ.feed.hosts': "Endereços que o servidor acessa (HTTPS): {hosts}.",
  'integ.feed.fixNow': "Abrir Corrigir agora",
  'integ.feed.details': "Detalhes",
  'integ.nvdKey.title': "Chave da API da NVD (opcional)",
  'integ.nvdKey.hint': "Com a chave, a sincronização da NVD fica cerca de dez vezes mais rápida e a NVD recusa menos pedidos por limite. Peça uma, de graça, em nvd.nist.gov/developers/request-an-api-key. Ela fica no cofre e vale na próxima sincronização, sem reiniciar.",
  'integ.nvdKey.set': "Há uma chave salva. Digite outra para trocar, ou remova.",
  'integ.nvdKey.none': "Sem chave: a sincronização espera entre as páginas para respeitar o limite público.",
  'integ.nvdKey.field': "Chave da API",
  'integ.nvdKey.save': "Salvar chave",
  'integ.nvdKey.remove': "Remover chave",
  'integ.nvdKey.saved': "Chave da NVD salva. Vale na próxima sincronização.",
  'integ.nvdKey.removed': "Chave da NVD removida.",
  'integ.nvdKey.adminOnly': "Só quem administra a instalação troca a chave.",
  'tk.label': "Chamado",
  'tk.search': "Busque por número, título, solicitante ou IC",
  'tk.searchHint': "Busca no {tool}. Os chamados desta máquina e os seus vêm primeiro; digitar o número também vale.",
  'tk.noItsm': "Não há ITSM conectado: digite o número do chamado.",
  'tk.noRead': "O {tool} não permite busca pelo Hive: o número fica como digitado.",
  'tk.readOff': "A leitura de chamados está desligada na integração de ITSM: o número fica como digitado.",
  'tk.searching': "Buscando no ITSM…",
  'tk.none': "Nenhum chamado encontrado para \"{q}\". Digite o número completo ou abra um chamado novo.",
  'tk.results': "Chamados no ITSM",
  'tk.notFound': "Não encontrado no ITSM. Confira o número ou escolha na lista.",
  'tk.unreachable': "O ITSM não respondeu; o Hive confere o número de novo ao salvar.",
  'tk.open': "Abrir chamado",
  'tk.openTitle': "Abrir chamado no {tool}",
  'tk.openText': "O Hive abre o chamado agora com a máquina, o motivo e quem pede, usando a categoria, o grupo e a prioridade do mapeamento da integração.",
  'tk.openTitleField': "Título",
  'tk.openDescField': "Descrição",
  'tk.openConfirm': "Abrir no ITSM",
  'tk.opened': "Chamado {key} aberto no ITSM.",
  'tk.openInItsm': "Abrir no ITSM",
  'tk.summary': "Chamado {key}",
  'tk.state.open': "Aberto",
  'tk.state.progress': "Em andamento",
  'tk.state.waiting': "Aguardando",
  'tk.state.resolved': "Resolvido",
  'tk.state.closed': "Fechado",
  'tk.priority': "Prioridade",
  'tk.requester': "Solicitante",
  'tk.assignee': "Responsável",
  'tk.assignedTo': "com {who}",
  'tk.ci': "IC",
  'tk.updated': "Atualizado",
  'tk.notes': "Últimas notas",
  'tk.requiredSr': "obrigatório",
  'tk.requiredHint': "exigido pela integração de ITSM",
  'tk.required': "Esta tela exige um chamado do ITSM: escolha um ou abra um novo no próprio campo.",
  'tk.closeQ': "Fechar também o chamado {key} no ITSM?",
  'tk.closeText': "O Hive resolve o chamado com o código de fechamento da integração e uma nota do que foi feito.",
  'tk.closeOk': "Fechar o chamado",
  'tk.closeKeep': "Manter aberto",
  'tk.closed': "Chamado fechado no ITSM.",
  'tk.closeBtn': "Fechar chamado",
  'tk.asset.title': "Chamados do ITSM",
  'tk.asset.empty': "Nenhum chamado do ITSM ligado a esta máquina ainda.",
  'tk.col.ticket': "Chamado",
  'tk.col.where': "Onde",
  'tk.col.by': "Por",
  'tk.col.when': "Quando",
  'tk.unverified': "não conferido no ITSM",
  'tk.closedTag': "fechado pelo Hive",
  'tk.screen.remote': "Acesso remoto",
  'tk.screen.elevation': "Administrador temporário",
  'tk.screen.change-window': "Janela de mudança (integridade)",
  'tk.screen.net-change-window': "Janela de mudança (rede)",
  'tk.screen.risk-acceptance': "Aceite de risco",
  'tk.screen.device-exception': "Exceção de USB",
  'tk.screen.deployment': "Implantação e patches",
  'tk.screen.access-review': "Revisão de acesso",
  'tk.screen.incident-response': "Resposta a incidente",
  'tk.screen.asset-stage': "Manutenção (ciclo de vida)",
  'tk.screen.remote-unattended': "Acesso remoto não assistido",
  'tkf.title': "Campos de chamado",
  'tkf.lead': "Como o campo \"Chamado\" de cada tela (acesso remoto, janelas de mudança, exceções, implantações, revisão de acesso, resposta a incidente) usa este ITSM.",
  'tkf.uses': "Usos",
  'tkf.read': "Ler: buscar e mostrar o resumo do chamado",
  'tkf.readHint': "Sem leitura o número fica como digitado e não é conferido.",
  'tkf.open': "Abrir: \"Abrir chamado\" no campo, já preenchido",
  'tkf.update': "Atualizar: o Hive escreve no chamado o que aconteceu",
  'tkf.close': "Fechar: resolver o chamado ao concluir (com confirmação)",
  'tkf.notReadable': "O {tool} ainda não permite busca pelo Hive: a leitura funciona com ServiceNow, Jira Service Management e GLPI.",
  'tkf.notes': "Notas escritas no chamado",
  'tkf.notesHint': "Marcadores: {asset} {actor} {by} {reason} {duration} {what} {result} {from} {to}. Deixe o texto padrão para ele sair no idioma da empresa.",
  'tkf.event.linked': "Chamado ligado a um registro",
  'tkf.event.remote.requested': "Acesso remoto pedido",
  'tkf.event.remote.approved': "Acesso remoto aprovado",
  'tkf.event.remote.started': "Sessão remota iniciada",
  'tkf.event.remote.ended': "Sessão remota encerrada (com duração)",
  'tkf.event.change.scheduled': "Janela de mudança registrada",
  'tkf.event.change.applied': "Mudança aplicada (implantação concluída, revisão fechada, resposta feita)",
  'tkf.event.exception.approved': "Exceção aprovada",
  'tkf.closeOn': "Fechar sozinho quando",
  'tkf.closeCode': "Código de fechamento",
  'tkf.closeCodeHint': "ServiceNow: código de fechamento (ex.: Solved Remotely (Permanently)); Jira: id da transição; GLPI: id do tipo de solução. Vazio: o padrão da conexão.",
  'tkf.fields': "Campos ao abrir pelo Hive",
  'tkf.fieldsHint': "Vazio: vale o mapeamento da conexão (severidade, grupos por tag, categorias).",
  'tkf.field.category': "Categoria",
  'tkf.field.group': "Grupo",
  'tkf.field.priority': "Prioridade",
  'tkf.states': "Estados da ferramenta",
  'tkf.statesHint': "Um estado da ferramenta que o Hive não reconhece (ex.: um personalizado) aparece como o estado do Hive escolhido aqui.",
  'tkf.stateRaw': "Estado na ferramenta",
  'tkf.stateHive': "Estado no Hive",
  'tkf.addState': "Incluir estado",
  'tkf.remove': "Remover",
  'tkf.required': "Chamado obrigatório",
  'tkf.requiredHint': "Nas telas escolhidas, salvar sem um chamado válido é recusado com a explicação. Chamado resolvido ou fechado não é aceito.",
  'tkf.save': "Salvar opções dos campos de chamado",
  'tkf.saved': "Opções dos campos de chamado salvas.",
};

const es: Record<K, string> = {
  'integ.title': 'Centro de integraciones',
  'integ.sub': 'Todas las conexiones con otros sistemas en un solo lugar. Cada conexión muestra para qué se usa, y cada pantalla que la usa configura solo su propio uso.',
  'integ.tab.catalog': 'Catálogo',
  'integ.tab.health': 'Salud de las conexiones',
  'integ.tab.api': 'API y cuentas de integración',
  'integ.tab.history': 'Historial',
  'integ.search': 'Buscar integración',
  'integ.searchPlaceholder': 'P. ej. Entra, Teams, ServiceNow, Kafka',
  'integ.category': 'Categoría',
  'integ.stateFilter': 'Estado',
  'integ.direction': 'Dirección',
  'integ.dir.all': 'Todas',
  'integ.dir.in': 'Entrada',
  'integ.dir.out': 'Salida',
  'integ.dir.both': 'Entrada y salida',
  'integ.dir.inHint': 'Trae datos a Hive',
  'integ.dir.outHint': 'Lleva datos de Hive',
  'integ.dir.bothHint': 'En ambos sentidos',
  'integ.state.connected': 'Conectada',
  'integ.state.attention': 'Atención',
  'integ.state.error': 'Con error',
  'integ.state.available': 'Disponible',
  'integ.state.disabled': 'Desactivada',
  'integ.sev.ok': 'OK',
  'integ.sev.attention': 'Atención',
  'integ.sev.error': 'Error',
  'integ.count.one': '{count} integración',
  'integ.count.other': '{count} integraciones',
  'integ.connectedCount.one': '{count} en uso',
  'integ.connectedCount.other': '{count} en uso',
  'integ.none': 'Ninguna integración con ese nombre.',
  'integ.noneText': 'Para cualquier herramienta con API, el conector genérico (REST/correo) está en la categoría ITSM.',
  'integ.noOAuth': 'Ruta de API con POST · token u OAuth 2.0/SAML',
  'integ.open': 'Abrir',
  'integ.connect': 'Conectar',
  'integ.cantConnect': 'Solo los perfiles que administran integraciones pueden conectar.',
  'integ.backToCatalog': 'Volver al catálogo',
  'integ.connectTitle': 'Conectar {name}',
  'integ.connectSub': 'Complete los campos de la integración. Los secretos van a la bóveda y nunca vuelven a mostrarse.',
  'integ.connectSubNoOAuth': 'Hive llama a la ruta de API de la herramienta con POST. La credencial viene de la bóveda: token fijo, usuario y contraseña, encabezado fijo u OAuth 2.0 (Hive obtiene el token — con client credentials o una aserción SAML firmada — y luego hace el POST con él).',
  'integ.testStep': 'Justo después de conectar, Hive prueba la conexión paso a paso y muestra dónde falla y cómo corregirlo.',
  'integ.connected': '{name} conectado.',
  'integ.connectedText': 'El primer uso ya está activo; los demás se activan en la conexión.',
  'integ.openConnection': 'Abrir la conexión',
  'integ.test.title': 'Prueba de la conexión',
  'integ.test.button': 'Probar conexión',
  'integ.test.running': 'Probando…',
  'integ.test.steps': 'Pasos de la prueba',
  'integ.test.ok': 'La conexión funciona.',
  'integ.test.failed': 'La prueba falló.',
  'integ.test.notAvailable': "Esta integración no tiene prueba de conexión: se comprueba cuando se usa.",
  'integ.edit': 'Editar conexión',
  'integ.editTitle': 'Editar {name}',
  'integ.editNote': 'Los campos secretos quedan en blanco: escriba solo si quiere reemplazar el valor guardado en la bóveda.',
  'integ.editUnavailable': 'Esta integración ya no está en el catálogo.',
  'integ.saved': '{name} guardado.',
  'integ.disconnect.ok': 'Desconectar',
  'integ.disconnect.title': '¿Desconectar {name}?',
  'integ.disconnect.text': 'Todos los usos de esta conexión se detienen y los secretos se borran de la bóveda. El historial sigue en el registro de auditoría.',
  'integ.disconnect.done': '{name} desconectado.',
  'integ.uses.title': 'Usos de esta conexión',
  'integ.uses.none': 'Esta integración no tiene usos.',
  'integ.uses.hint': 'Cada pantalla configura solo el uso (por ejemplo, qué canal o qué grupos); la conexión queda aquí.',
  'integ.use.enabled': 'Activo',
  'integ.use.disabled': 'Inactivo',
  'integ.use.on': 'Uso “{use}” activado.',
  'integ.use.off': 'Uso “{use}” desactivado.',
  'integ.use.needsConsent': 'Este uso necesita un permiso adicional: {perms}.',
  'integ.use.perms': 'Permisos: {perms}',
  'integ.use.later': "No disponible en esta instalación; se ofrece bajo demanda.",
  'integ.use.screenNote': 'Usa la credencial de la conexión; no hay nada que volver a escribir.',
  'integ.consent.open': 'Abrir consentimiento',
  'integ.consent.title': '¿Conceder permiso adicional para “{use}”?',
  'integ.consent.text': 'Apruebe estos permisos en el proveedor: {perms}. Después el uso puede activarse.',
  'integ.consent.ok': 'Lo aprobé en el proveedor',
  'integ.consent.done': 'Permiso registrado. Ya puede activar “{use}”.',
  'integ.data.title': 'Datos de la conexión',
  'integ.data.createdBy': 'Creada por',
  'integ.data.lastSync': 'Última prueba exitosa',
  'integ.data.never': 'nunca',
  'integ.health.title': 'Salud',
  'integ.health.noneHere': 'No hay avisos para esta conexión.',
  'integ.health.empty': 'Todavía no hay conexiones para vigilar.',
  'integ.health.emptyText': 'Credenciales por vencer, permisos revocados y pruebas fallidas aparecen aquí, con la corrección sugerida.',
  'integ.health.connection': 'Conexión',
  'integ.health.state': 'Estado',
  'integ.health.what': 'Qué está pasando',
  'integ.health.fix': 'Cómo resolverlo',
  'integ.health.checked': 'Verificado',
  'integ.health.note': 'Los problemas aquí son de las propias conexiones; las alertas sobre activos están en Alertas y eventos.',
  'integ.history.title': 'Historial de esta conexión',
  'integ.history.empty': 'Todavía no hay nada registrado.',
  'integ.history.when': 'Cuándo',
  'integ.history.who': 'Quién',
  'integ.history.what': 'Qué cambió',

  'api.intro.title': 'El 100% de la plataforma está en la API.',
  'api.intro.text': 'Todo lo que ve y hace en Hive existe como ruta REST (OpenAPI 3.1, /v1). Las integraciones con ITSM, ESM y CMDB nunca usan OAuth: las otras plataformas llaman a Hive con el token de una cuenta de integración.',
  'api.new': 'Nueva cuenta de integración',
  'api.reference': 'Documentación de la API (Swagger)',
  'api.download': 'Descargar openapi.json',
  'api.docs.title': 'Documentación de la API',
  'api.docs.back': 'API y cuentas de integración',
  'api.docs.intro': 'Todas las rutas de la plataforma, agrupadas por área, con parámetros, cuerpos y respuestas. "Try it out" llama a la API con el token de su sesión, dentro de sus permisos.',
  'api.docs.readOnly': 'Por defecto, solo se pueden probar solicitudes GET.',
  'api.docs.allowWrite': 'Permitir probar POST, PUT, PATCH y DELETE',
  'api.docs.writeOn': 'Solicitudes de escritura habilitadas: cambian datos reales en su nombre.',
  'api.docs.confirmTitle': '¿Habilitar solicitudes de escritura?',
  'api.docs.confirmText': 'Las solicitudes hechas aquí son reales y usan su sesión (crean, cambian y borran datos) y quedan en la auditoría. ¿Continuar?',
  'api.docs.confirmOk': 'Habilitar',
  'api.docs.loadFail': 'No se pudo cargar el visor de la documentación desde el núcleo. Aún puede descargar el contrato (openapi.json).',
  'alerts.expand': 'Ampliar',
  'alerts.expandHint': 'Abrir esta alerta en una ventana más grande',
  'alerts.expandedHere': 'Esta alerta está abierta en la ventana ampliada.',
  'alerts.alwaysExpand': 'Abrir siempre ampliado',
  'api.cmdbGuide': 'Poblar su CMDB en 3 pasos',
  'api.empty': 'Todavía no hay cuentas de integración.',
  'api.emptyText': 'Cree una para cada plataforma que lee o envía datos, como la CMDB de ServiceNow o Power BI.',
  'api.col.account': 'Cuenta de integración',
  'api.col.access': 'Puede acceder',
  'api.col.mode': 'Modo',
  'api.col.tokens': 'Token',
  'api.col.lastUse': 'Último uso',
  'api.noPurpose': 'sin descripción',
  'api.mode.read': 'Solo lectura',
  'api.mode.rw': 'Lectura y envío',
  'api.revoked': 'Revocada',
  'api.expires': 'vence {when}',
  'api.overlap': 'Dos tokens válidos durante el cambio (7 días).',
  'api.noActive': 'Ningún token válido',
  'api.never': 'nunca',
  'api.rotate.ok': 'Cambiar token',
  'api.rotate.title': '¿Cambiar el token de {name}?',
  'api.rotate.text': 'Se crea un token nuevo ahora. El actual sigue funcionando por 7 días, para actualizar la plataforma que consume sin interrupción; después vence solo.',
  'api.revoke.ok': 'Revocar',
  'api.revoke.title': '¿Revocar {name}?',
  'api.revoke.text': 'Las llamadas con esta cuenta se detienen de inmediato. No se puede deshacer: para conectar de nuevo, cree una cuenta nueva.',
  'api.revoke.done': '{name} revocada. Sus llamadas se detuvieron ahora.',
  'api.created.title': 'Cuenta de integración creada',
  'api.created.text': 'Cuenta {name} creada.',
  'api.rotated.title': 'Nuevo token para {name}',
  'api.rotated.text': 'Token nuevo creado. El anterior vale 7 días más.',
  'api.once': 'Copie el token ahora: solo se muestra esta vez y Hive guarda solo una huella de él.',
  'api.token': 'Token',
  'api.copyToken': 'Copiar token',
  'api.example': 'Ejemplo de llamada',
  'api.exampleHint': 'Reemplace <token> por el token de arriba. Cada llamada va al registro de auditoría.',
  'api.test': 'Probar el token ahora',
  'api.testOk': 'El token funciona: Hive reconoció la cuenta de integración.',
  'api.testFail': 'El token no fue aceptado.',
  'api.copiedClose': 'Copié el token — cerrar',
  'api.cmdb.title': 'Poblar la CMDB de su plataforma',
  'api.cmdb.step1': 'Carga inicial por lotes: exportación con CIs, clases y relaciones (NDJSON o CSV, reanudable).',
  'api.cmdb.step2': 'Solo lo que cambió: pida los elementos nuevos, cambiados y eliminados desde el último token de sincronización, con paginación por cursor.',
  'api.cmdb.step3': 'Avisos de cambio: Hive hace POST en su webhook en cada cambio (firma HMAC), o publica en el bus de eventos.',
  'api.cmdb.note': 'Mapeo listo para clases de ServiceNow CSDM o DMTF CIM, elegido en la cuenta de integración. Los CI modificados también pueden enviarse a un webhook: columna “Webhook de CI” en la tabla de arriba.',
  'api.inbound.title': 'Rutas de entrada (POST)',
  'api.inbound.text': 'Actualizaciones de tickets, cambios aprobados, CIs de otras herramientas y eventos externos llegan por POST, y cada ruta acepta solo el token de una cuenta con ese alcance.',
  'api.inbound.hint': 'Los errores vienen en lenguaje claro (RFC 9457), con qué pasó, por qué y cómo resolverlo.',
  'fed.tab': 'Federación',
  'fed.lead': 'Los equipos leídos de otras herramientas de inventario y CMDB entran al inventario emparejados con los activos que ya tiene. Cuando dos fuentes no coinciden, gana el número de prioridad más bajo; el agente siempre gana en los equipos que lo tienen.',
  'fed.sources': 'Fuentes de la federación',
  'fed.empty': 'Ninguna herramienta de inventario o CMDB conectada',
  'fed.emptyText': 'Conecte SCCM, OCS, KACE, ServiceNow, GLPI, Snipe-IT, ManageEngine, Lansweeper, Ivanti, Tanium, BMC Helix u otro Hive para traer sus equipos aquí.',
  'fed.emptyLink': 'Ver integraciones de inventario',
  'fed.col.source': 'Fuente',
  'fed.col.priority': 'Prioridad',
  'fed.col.every': 'Leer cada',
  'fed.col.last': 'Última lectura',
  'fed.col.assets': 'Activos',
  'fed.col.actions': 'Acciones',
  'fed.col.asset': 'Activo',
  'fed.col.field': 'Campo',
  'fed.col.current': 'Valor en el activo',
  'fed.col.said': 'Lo que dice cada fuente',
  'fed.hours': '{n} h',
  'fed.machines': '{n} equipos',
  'fed.status.ok': 'Leída',
  'fed.status.running': 'Leyendo',
  'fed.status.failed': 'Falló',
  'fed.status.stopped': 'Detenida',
  'fed.status.never': 'Aún no leída',
  'fed.test': 'Probar',
  'fed.testing': 'Probando…',
  'fed.sync': 'Leer ahora',
  'fed.syncing': 'Leyendo…',
  'fed.testOk': '{name} respondió: el colector alcanzó la herramienta y leyó un equipo.',
  'fed.syncOk': '{name} leída: {n} equipos aplicados al inventario.',
  'fed.failed': 'No se pudo leer {name}.',
  'fed.saved': 'Fuente guardada; los activos se evaluaron de nuevo.',
  'fed.precedence': 'Precedencia: agente (0) › reglas por campo › prioridad de la fuente. El equipo que desaparece en una lectura completa pierde el vínculo con esa fuente; el activo se mantiene.',
  'fed.rules': 'Reglas por campo',
  'fed.rulesLead': 'Úselo cuando una fuente es la referencia solo para un campo, por ejemplo el modelo de la herramienta de gestión de activos.',
  'fed.addRule': 'Agregar regla',
  'fed.removeRule': 'Quitar regla',
  'fed.saveRules': 'Guardar reglas',
  'fed.rulesSaved': 'Reglas guardadas; los activos se evaluaron de nuevo.',
  'fed.conflicts': 'Conflictos entre fuentes',
  'fed.noConflicts': 'Las fuentes coinciden en todos los campos.',
  'fed.agent': 'agente',
  'fed.field.hostname': 'Nombre',
  'fed.field.fqdn': 'FQDN',
  'fed.field.serial': 'Número de serie',
  'fed.field.hwUuid': 'UUID del hardware',
  'fed.field.vendor': 'Fabricante',
  'fed.field.model': 'Modelo',
  'fed.field.osName': 'Sistema operativo',
  'fed.field.osVersion': 'Versión del sistema',
  'fed.field.primaryUser': 'Usuario principal',
  'fed.field.assetTag': 'Etiqueta de activo',
  'fed.asset.tab': 'Fuentes',
  'fed.asset.title': 'De dónde vino cada dato',
  'fed.asset.lead': 'Cada campo muestra el valor en uso, quién lo informó y lo que dice cada fuente.',
  'fed.asset.agent': 'Agente · visto {when}',
  'fed.asset.noAgent': 'Sin agente',
  'fed.asset.from': 'Informado por',
  'fed.asset.conflict': 'Difiere',
  'fed.asset.priority': 'prioridad {n}',
  'fed.asset.empty': 'Solo el agente informa este activo',
  'fed.asset.emptyText': 'Cuando una herramienta de inventario o CMDB también conozca este equipo, lo que dice aparece aquí.',
  'rpx.title': "Proxy de lectura (opcional)",
  'rpx.lead': "Otra plataforma lee los datos de Hive por un proxy liviano en la DMZ (hive-readproxy): solo GET en las rutas fijas de abajo, con la cuenta de integración de solo lectura de la propia plataforma, caché corta, límite de llamadas y cada lectura en la registro de auditoría. Nunca alcanza tareas, implementaciones, scripts, acceso remoto ni agentes.",
  'rpx.state.on': "Encendido",
  'rpx.state.off': "Apagado",
  'rpx.turnOn': "Encender",
  'rpx.turnOff': "Apagar",
  'rpx.rotate': "Nueva clave del proxy",
  'rpx.key': "Clave del proxy que termina en {last4}",
  'rpx.noKey': "Aún sin clave: se crea al encender el proxy.",
  'rpx.changed': "Cambiado por {who} {when}",
  'rpx.keyOnce': "Copie la clave del proxy ahora: se muestra una sola vez. Póngala en la configuración del proxy (-key-file).",
  'rpx.copyKey': "Copiar clave",
  'rpx.routes': "Rutas expuestas (solo GET)",
  'rpx.col.path': "Ruta",
  'rpx.col.domain': "Datos",
  'rpx.col.scopes': "La cuenta necesita",
  'rpx.domain.assets': "Activos",
  'rpx.domain.alerts': "Alertas",
  'rpx.domain.vulnerabilities': "Vulnerabilidades",
  'rpx.domain.metrics': "Métricas",
  'rpx.headers': "El proxy envía su clave a Hive en {key} y la dirección de la plataforma en {client}.",
  'rpx.on': "Proxy de lectura encendido",
  'rpx.off': "Proxy de lectura apagado",
  'rpx.rotated': "Nueva clave del proxy creada; la anterior dejó de valer.",
  'rpx.rotateConfirm.title': "¿Crear una nueva clave del proxy?",
  'rpx.rotateConfirm.text': "La clave actual deja de valer en el acto; actualice la configuración del proxy con la nueva.",
  'rpx.offConfirm.title': "¿Apagar el proxy de lectura?",
  'rpx.offConfirm.text': "Las lecturas por el proxy se rechazan en el acto. La API con cuentas de integración sigue funcionando.",
  'iso.button': "Aislar de la red",
  'iso.lead': "Después de la aprobación, el agente bloquea todo el tráfico con el firewall del sistema, salvo el canal con Hive, el DNS y el DHCP. Termina solo cuando vence el plazo de seguridad, incluso sin Hive.",
  'iso.leadEdr': "El EDR conectado a este equipo lo aísla después de la aprobación.",
  'iso.via': "Aislar por",
  'iso.via.agent': "Agente de Hive (firewall del sistema)",
  'iso.via.edr': "Sensor del EDR",
  'iso.minutes': "Plazo de seguridad (minutos)",
  'iso.minutesHint': "Entre 5 minutos y 7 días; el agente libera el equipo solo cuando vence.",
  'iso.ports': "Puertos del servicio que siguen abiertos (servidores)",
  'iso.portsHint': "Puertos TCP separados por coma (p. ej. 443, 1433). Deje vacío en estaciones.",
  'iso.state.on': "Aislado hasta {when}",
  'iso.state.onEdr': "Aislado por el EDR",
  'iso.state.off': "No aislado",
  'iso.state.expired': "El aislamiento terminó {when} (plazo de seguridad)",
  'iso.open': "Hay un pedido de aislamiento en espera o en ejecución.",
  'iso.effect': "El equipo sale de la red; solo el canal con Hive (y los puertos de servicio declarados) sigue abierto hasta el plazo de seguridad.",
  'rsp.a.release': "Liberar del aislamiento de red",
  'rsp.effect.release': "El equipo vuelve a la red: el agente quita sus reglas del firewall (o el EDR lo libera).",
  'dc.cap.response-isolate': "Aislar de la red y liberar",
  'integ.onDemandHint': "Este conector aún no forma parte del producto. Pídalo y el equipo de Hive ve su solicitud.",
  'integ.request': "Pedir este conector",
  'integ.requested': "Solicitud de {name} registrada: está en la auditoría y el equipo de Hive fue avisado.",
  'integ.builtin': "Ya incluida — se sincroniza sola",
  'integ.builtin.sub': "Bases públicas de vulnerabilidades que ya vienen con Hive: no hay nada que conectar.",
  'integ.builtin.lead': "Hive lee estas bases públicas por sí solo, para todas las empresas: CISA KEV y NVD cada 2 horas (NVD solo para los productos en uso), OSV.dev cada 6 horas y FIRST EPSS una vez al día.",
  'integ.feed.kev': "CISA KEV",
  'integ.feed.nvd': "NVD",
  'integ.feed.osv': "OSV.dev",
  'integ.feed.epss': "FIRST EPSS",
  'integ.feed.state.ok': "Al día",
  'integ.feed.state.stale': "Desactualizada",
  'integ.feed.state.attention': "Fallando",
  'integ.feed.state.never': "Aún no sincronizada",
  'integ.feed.last': "sincronizada {when}",
  'integ.feed.never': "nunca sincronizada",
  'integ.feed.every': "cada {n} h",
  'integ.feed.unreachable': "El servidor no alcanza {hosts}. Permita HTTPS (puerto 443) hacia esas direcciones en el firewall, el proxy o el egress de OpenShift.",
  'integ.feed.error': "último error: {error}",
  'integ.feed.hosts': "Direcciones a las que accede el servidor (HTTPS): {hosts}.",
  'integ.feed.fixNow': "Abrir Corregir ahora",
  'integ.feed.details': "Detalles",
  'integ.nvdKey.title': "Clave de la API de la NVD (opcional)",
  'integ.nvdKey.hint': "Con la clave, la sincronización de la NVD es unas diez veces más rápida y la NVD rechaza menos solicitudes por límite. Pida una, gratis, en nvd.nist.gov/developers/request-an-api-key. Se guarda en la bóveda y vale en la próxima sincronización, sin reiniciar.",
  'integ.nvdKey.set': "Hay una clave guardada. Escriba otra para cambiarla, o elimínela.",
  'integ.nvdKey.none': "Sin clave: la sincronización espera entre páginas para respetar el límite público.",
  'integ.nvdKey.field': "Clave de la API",
  'integ.nvdKey.save': "Guardar clave",
  'integ.nvdKey.remove': "Eliminar clave",
  'integ.nvdKey.saved': "Clave de la NVD guardada. Vale en la próxima sincronización.",
  'integ.nvdKey.removed': "Clave de la NVD eliminada.",
  'integ.nvdKey.adminOnly': "Solo quien administra la instalación cambia la clave.",
  'tk.label': "Ticket",
  'tk.search': "Busque por número, título, solicitante o CI",
  'tk.searchHint': "Busca en {tool}. Los tickets de este equipo y los suyos aparecen primero; escribir el número también sirve.",
  'tk.noItsm': "No hay ITSM conectado: escriba el número del ticket.",
  'tk.noRead': "{tool} no permite buscar desde Hive: el número queda como se escribió.",
  'tk.readOff': "La lectura de tickets está desactivada en la integración de ITSM: el número queda como se escribió.",
  'tk.searching': "Buscando en el ITSM…",
  'tk.none': "No se encontró ningún ticket para \"{q}\". Escriba el número completo o abra un ticket nuevo.",
  'tk.results': "Tickets en el ITSM",
  'tk.notFound': "No se encontró en el ITSM. Revise el número o elíjalo en la lista.",
  'tk.unreachable': "El ITSM no respondió; Hive verifica el número de nuevo al guardar.",
  'tk.open': "Abrir ticket",
  'tk.openTitle': "Abrir ticket en {tool}",
  'tk.openText': "Hive abre el ticket ahora con el equipo, el motivo y quién lo pide, usando la categoría, el grupo y la prioridad del mapeo de la integración.",
  'tk.openTitleField': "Título",
  'tk.openDescField': "Descripción",
  'tk.openConfirm': "Abrir en el ITSM",
  'tk.opened': "Ticket {key} abierto en el ITSM.",
  'tk.openInItsm': "Abrir en el ITSM",
  'tk.summary': "Ticket {key}",
  'tk.state.open': "Abierto",
  'tk.state.progress': "En curso",
  'tk.state.waiting': "En espera",
  'tk.state.resolved': "Resuelto",
  'tk.state.closed': "Cerrado",
  'tk.priority': "Prioridad",
  'tk.requester': "Solicitante",
  'tk.assignee': "Responsable",
  'tk.assignedTo': "con {who}",
  'tk.ci': "CI",
  'tk.updated': "Actualizado",
  'tk.notes': "Últimas notas",
  'tk.requiredSr': "obligatorio",
  'tk.requiredHint': "exigido por la integración de ITSM",
  'tk.required': "Esta pantalla exige un ticket del ITSM: elija uno o abra uno nuevo en el propio campo.",
  'tk.closeQ': "¿Cerrar también el ticket {key} en el ITSM?",
  'tk.closeText': "Hive resuelve el ticket con el código de cierre de la integración y una nota de lo que se hizo.",
  'tk.closeOk': "Cerrar el ticket",
  'tk.closeKeep': "Mantenerlo abierto",
  'tk.closed': "Ticket cerrado en el ITSM.",
  'tk.closeBtn': "Cerrar ticket",
  'tk.asset.title': "Tickets del ITSM",
  'tk.asset.empty': "Ningún ticket del ITSM vinculado a este equipo todavía.",
  'tk.col.ticket': "Ticket",
  'tk.col.where': "Dónde",
  'tk.col.by': "Por",
  'tk.col.when': "Cuándo",
  'tk.unverified': "no verificado en el ITSM",
  'tk.closedTag': "cerrado por Hive",
  'tk.screen.remote': "Acceso remoto",
  'tk.screen.elevation': "Administrador temporal",
  'tk.screen.change-window': "Ventana de cambio (integridad)",
  'tk.screen.net-change-window': "Ventana de cambio (red)",
  'tk.screen.risk-acceptance': "Aceptación de riesgo",
  'tk.screen.device-exception': "Excepción de USB",
  'tk.screen.deployment': "Implementación y parches",
  'tk.screen.access-review': "Revisión de acceso",
  'tk.screen.incident-response': "Respuesta a incidente",
  'tk.screen.asset-stage': "Mantenimiento (ciclo de vida)",
  'tk.screen.remote-unattended': "Acceso remoto desatendido",
  'tkf.title': "Campos de ticket",
  'tkf.lead': "Cómo el campo \"Ticket\" de cada pantalla (acceso remoto, ventanas de cambio, excepciones, implementaciones, revisión de acceso, respuesta a incidente) usa este ITSM.",
  'tkf.uses': "Usos",
  'tkf.read': "Leer: buscar y mostrar el resumen del ticket",
  'tkf.readHint': "Sin lectura el número queda como se escribió y no se verifica.",
  'tkf.open': "Abrir: \"Abrir ticket\" en el campo, ya completado",
  'tkf.update': "Actualizar: Hive escribe en el ticket lo que pasó",
  'tkf.close': "Cerrar: resolver el ticket al terminar (con confirmación)",
  'tkf.notReadable': "{tool} todavía no permite buscar desde Hive: la lectura funciona con ServiceNow, Jira Service Management y GLPI.",
  'tkf.notes': "Notas escritas en el ticket",
  'tkf.notesHint': "Marcadores: {asset} {actor} {by} {reason} {duration} {what} {result} {from} {to}. Deje el texto predeterminado para que salga en el idioma de la empresa.",
  'tkf.event.linked': "Ticket vinculado a un registro",
  'tkf.event.remote.requested': "Acceso remoto solicitado",
  'tkf.event.remote.approved': "Acceso remoto aprobado",
  'tkf.event.remote.started': "Sesión remota iniciada",
  'tkf.event.remote.ended': "Sesión remota finalizada (con duración)",
  'tkf.event.change.scheduled': "Ventana de cambio registrada",
  'tkf.event.change.applied': "Cambio aplicado (implementación terminada, revisión cerrada, respuesta hecha)",
  'tkf.event.exception.approved': "Excepción aprobada",
  'tkf.closeOn': "Cerrar solo cuando",
  'tkf.closeCode': "Código de cierre",
  'tkf.closeCodeHint': "ServiceNow: código de cierre (p. ej. Solved Remotely (Permanently)); Jira: id de la transición; GLPI: id del tipo de solución. Vacío: el predeterminado de la conexión.",
  'tkf.fields': "Campos al abrir desde Hive",
  'tkf.fieldsHint': "Vacío: se aplica el mapeo de la conexión (severidad, grupos por etiqueta, categorías).",
  'tkf.field.category': "Categoría",
  'tkf.field.group': "Grupo",
  'tkf.field.priority': "Prioridad",
  'tkf.states': "Estados de la herramienta",
  'tkf.statesHint': "Un estado de la herramienta que Hive no reconoce (p. ej., uno personalizado) aparece como el estado de Hive elegido aquí.",
  'tkf.stateRaw': "Estado en la herramienta",
  'tkf.stateHive': "Estado en Hive",
  'tkf.addState': "Agregar estado",
  'tkf.remove': "Quitar",
  'tkf.required': "Ticket obligatorio",
  'tkf.requiredHint': "En las pantallas elegidas, guardar sin un ticket válido se rechaza con la explicación. No se acepta un ticket resuelto o cerrado.",
  'tkf.save': "Guardar opciones de los campos de ticket",
  'tkf.saved': "Opciones de los campos de ticket guardadas.",
};

export const integrationsMessages = { en, 'pt-BR': ptBR, es } as const;
